<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove() {
      if (!this.disabled) {
        this.$emit('remove');
      }
    },
  },
});
</script>
<template>
  <div
    v-if="!disabled"
    class="cly-vue-remover"
    @click="remove"
  >
    <slot>
      <i class="el-icon-delete" />
    </slot>
  </div>
</template>
